import React from "react";
import { RaisedButton, TextField, Checkbox } from "material-ui";
import Select from "react-select";
import moment from "moment-timezone";

import LinkLike from "./link-like.jsx";
import DatePicker from "./datepicker.jsx";
import ImageDropzone from "./image-dropzone.jsx";

// https://github.com/grammakov/USA-cities-and-states
const STATES = "Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming|Puerto Rico|Virgin Islands|Washington, D.C.|US Armed Forces Pacific|American Samoa|Guam|Palau|Federated States of Micronesia|Northern Mariana Islands|Marshall Islands|US Armed Forces Europe".split(
  "|"
);

class SupplementaryDataEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  getStyles() {
    return {
      container: {
        margin: "15px 0"
      },
      requiredNote: {
        position: "absolute",
        bottom: 16 + 74,
        fontSize: "0.8em"
      },
      label: {
        marginTop: "1em",
        fontWeight: "bold"
      },
      description: {
        fontSize: "0.8em",
        marginBottom: -10
      },
      inputContainer: {
        textAlign: "left",
        margin: "0 auto",
        maxWidth: "90%",
        width: 300
      },
      actions: {
        marginTop: 15
      },
      dropzone: {
        height: "auto",
        fontSize: "0.75em",
        lineHeight: "1.25",
        padding: 10,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      existingImage: {
        cursor: "pointer",
        height: 75
      },
      existingImageInstruction: {
        fontSize: "0.75em",
        marginTop: 5,
        marginBottom: 5
      }
    };
  }

  onChange(id, e, value) {
    this.props.updateDataValue(
      id,
      typeof value !== "undefined" ? value : e.target.value
    );
  }

  render() {
    let styles = this.getStyles();

    let { requiredNoticeStyle } = this.props;

    let inputs = this.props.fields
      .filter(f => !f.hidden)
      .map((f, i) => {
        let inner,
          value = this.props.data[f.key];

        if (f.type === "state") {
          f.type = "select";
          f.options = STATES;
          if (f.show_none_option) {
            f.options = [
              f.none_option_text || "I don't live in the United States"
            ].concat(f.options);
          }
        }

        if (f.type === "select") {
          inner = (
            <Select
              name={f.key}
              style={{ marginTop: 20 }}
              value={value}
              options={f.options.map(o => {
                return { value: o, label: o };
              })}
              multi={f.multiple}
              onChange={v =>
                this.onChange(
                  f.key,
                  null,
                  f.multiple ? v.map(i => i.value) : v && v.value
                )
              }
            />
          );
        } else if (f.type === "checkbox") {
          inner = (
            <Checkbox
              name={f.key}
              style={{ marginTop: 14 }}
              checked={value}
              onCheck={e => this.onChange(f.key, null, !value)}
              label={f.checkbox_label}
            />
          );
        } else if (f.type === "date") {
          inner = (
            <DatePicker
              name={f.key}
              returnFormat="YYYY-MM-DD"
              displayFormat="MM/DD/YYYY"
              fullWidth={true}
              value={value}
              onChange={v => this.onChange(f.key, null, v)}
            />
          );
        } else if (f.type === "image") {
          inner = (
            <div style={{ marginTop: 20 }}>
              {value ? (
                <img
                  src={value.pending_upload ? value.data : value + "?h=300"}
                  style={{
                    maxHeight: 150,
                    maxWidth: "100%",
                    backgroundColor: "hsla(31,15%,50%,.1)"
                  }}
                />
              ) : null}
              <ImageDropzone
                crop={f.square ? { width: 1, height: 1 } : true}
                hideCropTip={true}
                dataUrl={true}
                style={styles.dropzone}
                ref={r => {
                  this.dropzone = r;
                }}
                onDrop={(files, { fromImageUrl }) => {
                  this.onChange(f.key, null, {
                    data: files[0],
                    pending_upload: true,
                    do_not_persist: !!fromImageUrl
                  });
                }}
              >
                <div>
                  Drag &amp; drop an image here, or click to select.
                  {value ? (
                    <LinkLike
                      style={{ display: "block" }}
                      onClick={e => {
                        this.onChange(f.key, null, null);
                      }}
                    >
                      [Delete current image]
                    </LinkLike>
                  ) : null}
                </div>
              </ImageDropzone>
              {!value &&
              this.props.existingImages &&
              this.props.existingImages.length ? (
                <div>
                  <div style={styles.existingImageInstruction}>
                    or select one of your previously uploaded images:
                  </div>
                  <div>
                    {this.props.existingImages.reverse().map(src => {
                      return (
                        <img
                          src={src}
                          style={styles.existingImage}
                          onClick={e => {
                            this.dropzone.showCropperForImage(src);
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
          );
        } else {
          inner = (
            <TextField
              name={f.key}
              value={value}
              fullWidth={true}
              multiLine={f.multiline || f.type === "address"}
              onChange={this.onChange.bind(null, f.key)}
            />
          );
        }

        return (
          <div key={f.key} style={styles.inputContainer}>
            <label htmlFor={f.key}>
              <div style={styles.label}>
                {f.label}
                {f.required && (
                  <span style={{ color: "rgb(229, 57, 53)" }}>*</span>
                )}
              </div>
              <div style={styles.description}>{f.description}</div>
            </label>
            {inner}
          </div>
        );
      });

    return (
      <div style={styles.container}>
        {inputs}
        <div
          style={Object.assign({}, styles.requiredNote, requiredNoticeStyle)}
        >
          Required fields are marked with a{" "}
          <span style={{ color: "rgb(229, 57, 53)" }}>*</span>.
        </div>
      </div>
    );
  }
}

export default SupplementaryDataEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/supplementary-data-editor.jsx